const dictionary = {
  custom: {
    email: {
      required: "Email address is required.",
      email: "Must be a valid email address.",
      max: "Email must be 50 characters or less."
    },
    title: {
      required: "The project name is required."
    },
    emailForget: {
      required: "Enter email address.",
      email: "Must be a valid email address.",
      max: "Email must be 50 characters or less."
    },
    confirmPassword: {
      min: "Confirm password.",
      required: "Confirm password.",
      is: "Passwords do not match."
    },
    password: {
      required: "Password is required.",
      min: "Password must be at least 8 characters."
    },
    kit_id: {
      required: "Your Kit ID is required..",
      length: "Kit ID must be 11 characters.."
    },
    confirm_kit_id: {
      required: "Re-enter Kit ID to confirm.",
      is: "Kit ID does not match."
    },
    first_name: {
      required: "First name required.",
      max: "This field must be 50 characters or less."
    },
    last_name: {
      required: "Last name required.",
      max: "This field must be 50 characters or less."
    },
    phone: {
      required: "Phone number required.",
      regex: "Phone number is invalid."
    },
    passwordProfile: {
      required: "Create a password.",
      min: "Your password must be at least 8 characters."
    },
    verifyPassword: {
      required: "Confirm password.",
      is: "Passwords do not match."
    },
    old_password: {
      required: "Enter old password.",
      min: "Old password must be at least 8 characters."
    },
    password_home: {
      required: "Enter new password.",
      min: "New password must be at least 8 characters."
    },
    password_confirmation_home: {
      required: "Confirm new password.",
      is: "Passwords do not match."
    },
    kit_dashboard: {
      required: "Kit ID required.",
      length: "Kit ID must be 11 characters.",
      kitformat: 'Kit ID must include F1, F2, F3, R1, R2, or R3, before or after the hyphen.',
    },
    rooms: {
      required: "Number of Rooms required.",
      max_value: "Must be 3 or less."
    },
    paymentMethod: {
      required: "Please make a selection.",
      custom: "Please make a selection.", // Custom message for no selection
    },
    email_admin: {
      required: "Enter email address.",
      email: "Must be a valid email address."
    },
    first_name_admin: {
      required: "First name required."
    },
    last_name_admin: {
      required: "Last name required."
    },
    collected_last_name: {
      required: "Last name required.",
      max: "Max length: 50."
    },
    collected_first_name: {
      required: "First name required.",
      max: "Max length: 50."
    },
    collected_email_admin: {
      required: "Enter email address.",
      email: "Must be a valid email address."
    },
    units_per_price : {
      required: "Enter unit per price.",
      decimal: "Must be a number Value."
    },
    available_inventory: {
      required: "Enter available inventory.",
      numeric: "Must be a number Value."
    },
   
  }
};

import VeeValidate, { Validator } from "vee-validate";
import axios from "axios";
Validator.localize("en", dictionary);
Validator.extend('email_exist', {
  getMessage: field => 'Email already exist',
  validate: (value) => {
      const data ={"email" :value};
      return axios.put("/v1/profile/validate/email", data).then(res => {
       if (res.data.data.email_exist) {
          return false;
        } else {
          return true;
        }
      });
  }
});

Validator.extend('email_exist_other_user', {
  getMessage: field => 'Email already user exist',
  params: ['customData'],
  validate: (value, customData ) => {
      const data ={"email" :value , "id":customData[0]};
      return axios.put("/v1/profile/validate/email", data).then(res => {
       if (res.data.data.email_exist) {
          return false;
        } else {
          return true;
        }
      });
  }
});

Validator.extend('email_exist_other_customer', {
  getMessage: field => 'Email already exist',
  params: ['customData'],
  validate: (value, customData ) => {
      const data ={"email" :value , "id":customData[0]};
      return axios.put("/v1/profile/validate/email", data).then(res => {
       if (res.data.data.email_exist) {
          return false;
        } else {
          return true;
        }
      });
  }
});

Validator.extend('paymentMethodNotEmpty', {
  validate: (value) => {
    return value != null;
  },
  message: 'Please make a selection.',
});

// Extend the Validator with a custom rule
Validator.extend('kitformat', {
  // Define the validation function
  validate: (value) => {
    let kitId = parseKitId(value);
    // Ensure the value has at least 4 characters
    if (kitId.length < 4) return false;
    
    // Check the 3rd and 4th characters
    const thirdChar = kitId[2];
    const fourthChar = kitId[3];
    const FirstChar = kitId[0];
    const SecondChar = kitId[1];
    return ((thirdChar === 'F' || thirdChar === 'R') && 
           (fourthChar === '1' || fourthChar === '2' || fourthChar === '3')||(FirstChar === 'F' || FirstChar === 'R') && 
           (SecondChar === '1' || SecondChar === '2' || SecondChar === '3') );
  },
  // Define the error message
  message: 'Kit ID must include F1, F2, F3, R1, R2, or R3.',
});

Validator.extend('phone_exist', {
  getMessage: (field,params,data) => data.message,
  validate: (value) => {
      const data ={"phone" :value};
      return axios.put("/v1/profile/validate/phone", data).then(res => {
       if (res.data.data.phone_exist) {
        return true;
        } else {
          return new Promise(resolve => {
            resolve({
                valid: false,
                data: { message: value.replace(/[\s-()+]/g, "").substring(0,3)+' is not a valid area code.' },
              });
          });
        }
      });
  }
});
function parseKitId(kitId) {
  const DASHES_REGEX = /[-\s]/g;
  return kitId
    ? kitId
        .replace(DASHES_REGEX, "")
        .substr(0, 11)
        .toUpperCase()
    : undefined;
}
export default VeeValidate;
